import { Config } from '@chegg-wt/core/config'
import { SessionData } from '@chegg/rio-sdk-web'
import { isProduction } from '@chegg-wt/core/utils/env'
import { getOrSetVCookie } from '@chegg-wt/core/utils/getVCookie'
import { AppState } from '@chegg-wt/core/state'
import { getCookie, Cookies } from '@chegg-wt/core/utils/cookies'
import { viewExperienceMap } from '../../utils'
import {
  getAuthState,
  getCheggUserUuid,
  productMap,
  getSubscriptionStatus,
} from '../../utils/auth'
import {
  PROD_RIO_ENDPOINT,
  NON_PROD_RIO_ENDPOINT,
  APP_ID,
  BUSINESS_UNIT,
} from '../constants'

export const getRioConfig = (state: AppState, view_name: string) => {
  const isProd = isProduction()
  const LOG_EVENT_LAMBDA_URL = isProd ? PROD_RIO_ENDPOINT : NON_PROD_RIO_ENDPOINT
  const RSW_ENDPOINT = LOG_EVENT_LAMBDA_URL
  const site = Config.tokenSiteCode
  const getExpCookie = () => getCookie(Cookies.RioClientExperiments)

  return {
    endpoint: RSW_ENDPOINT,
    appId: APP_ID,
    property: site,
    authState: getAuthState(state),
    cheggUuid: getCheggUserUuid(state) || undefined,
    uvn: getOrSetVCookie(Config.cookieDomain),
    clientExperiments: getExpCookie(),
    subscriptions: [{ product: productMap[site], status: getSubscriptionStatus(state) }],
    view: {
      property: BUSINESS_UNIT,
      experience: viewExperienceMap[site],
      view_name: view_name || '',
    },
  } as SessionData
}
